import { Flex, Text } from '@chakra-ui/react';
import { QR_CODE_CREATED } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';
import { addNewWidget, getInitialWidgetPosition, useAppDispatch } from 'modules/Editor/store';
import { useToast } from 'modules/common/components/Toast';
import { useTranslation } from 'react-i18next';
import { generateDefaultData } from 'widgets/QRCodeWidget/QRCodeWidget.helpers';

import { QRCodeGenerator } from './QRCodeGenerator';

export const QRCodeMenu = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();

  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.qrCodeMenu' });

  const addQRCodeWidget = (url: string) => {
    const { top, left } = getInitialWidgetPosition();
    const widgetData = generateDefaultData(url, top, left);
    dispatch(addNewWidget(widgetData));

    Mixpanel.track(QR_CODE_CREATED.eventName, { from: QR_CODE_CREATED.from.LeftPanel });
    toast({ title: t('qrSuccess') });
  };

  return (
    <Flex direction={'column'} p={4}>
      <Text fontSize='sm' pb='4'>
        {t('description')}
      </Text>
      <QRCodeGenerator onChange={addQRCodeWidget} />
    </Flex>
  );
};
